
				var addMethods = require("../../../../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = []
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "1ab66c50ccb7fdc42b0b.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			